import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ExpenseCard = ({ expense, onEdit, onDelete, onDuplicate }) => {
  const getStatusColor = (status) => {
    switch (status) {
      case 'approved':
        return 'bg-success/10 text-success border-success/20';
      case 'pending':
        return 'bg-warning/10 text-warning border-warning/20';
      case 'rejected':
        return 'bg-error/10 text-error border-error/20';
      default:
        return 'bg-muted text-muted-foreground border-border';
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6 hover:shadow-elevated transition-shadow duration-200">
      <div className="flex items-start justify-between mb-4">
        <div>
          <h3 className="font-semibold text-foreground">{expense?.description}</h3>
          <p className="text-sm text-muted-foreground">{expense?.vendorName}</p>
        </div>
        <span className={`px-2 py-1 text-xs font-medium rounded-full border ${getStatusColor(expense?.status)}`}>
          {expense?.status}
        </span>
      </div>
      <div className="grid grid-cols-2 gap-4 mb-4">
        <div>
          <p className="text-xs text-muted-foreground">Amount</p>
          <p className="font-semibold text-foreground">${expense?.amount?.toLocaleString()}</p>
        </div>
        <div>
          <p className="text-xs text-muted-foreground">Date</p>
          <p className="font-semibold text-foreground">{new Date(expense.date)?.toLocaleDateString()}</p>
        </div>
      </div>
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-2">
          <Icon name="Tag" size={14} className="text-muted-foreground" />
          <span className="text-sm text-muted-foreground">{expense?.category}</span>
        </div>
        <div className="flex items-center space-x-2">
          <Button variant="ghost" size="sm" onClick={() => onDuplicate(expense)}>
            <Icon name="Copy" size={16} />
          </Button>
          <Button variant="ghost" size="sm" onClick={() => onEdit(expense)}>
            <Icon name="Edit" size={16} />
          </Button>
          <Button variant="ghost" size="sm" onClick={() => onDelete(expense)}>
            <Icon name="Trash2" size={16} />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ExpenseCard;